import * as React from 'react';

import { triangleUpIcon, } from './shared';

import { EXTRA_SMALL_ICON_BASE_SRC, } from '../../../../../Shared'

const barGraphIncreasingIcon = <img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/bar-graph-increasing.svg`} />

interface GrowthSummaryProps {
  showGrowthSummary?: boolean;
  skillsGrowth?: number;
  name?: string;
  growthSummaryLink?: string;
  eligibleForQuestionScoring?: boolean,
}

const GrowthSummarySection = ({ showGrowthSummary, skillsGrowth, name, growthSummaryLink, eligibleForQuestionScoring, }: GrowthSummaryProps) => {

  if (!eligibleForQuestionScoring && showGrowthSummary) {
    return (
      <section className="growth-summary">
        <div>
          <h4>Growth summary</h4>
          <p>{barGraphIncreasingIcon}<span>Not available for diagnostics completed before August 2023.</span></p>
        </div>
      </section>
    )
  } else if (showGrowthSummary) {
    const growth = skillsGrowth > 0 ? <span className="growth">{triangleUpIcon}{`${skillsGrowth}%`}</span> : <span className="no-growth"> No growth yet</span>
    return (
      <section className="growth-summary">
        <div>
          <h4>Growth summary</h4>
          {skillsGrowth !== null && <p>{barGraphIncreasingIcon}<span>Skills growth:{growth}</span></p>}
        </div>
        <div>
          <a className="diagnostic-reports-button quill-button extra-small grey outlined focus-on-light" href={growthSummaryLink}>View growth</a>
        </div>
      </section>
    )
  }

  return (
    <section className="growth-summary">
      <div>
        <h4>Growth summary</h4>
        <p>{barGraphIncreasingIcon}<span>To see how your students have grown, first assign the {name} (Post)</span></p>
      </div>
    </section>
  )

}

export default GrowthSummarySection
